import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import rockAndRoll from "../../../../../../../../../assets/images/rock-and-roll/rock-and-roll.png";
import { useTheme } from "../../../../../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { node_server } from "../../../../../../../../../constants";
import { updateShoutoutsData } from "../../../../../../../../../store/slices/profile/shoutoutsSlice";
import truncateText from "../../../../../../../../../helpers/truncateText";

function Top({ data }) {
  const { theme } = useTheme();
  const user = useSelector((state) => state.user.value);
  const {
    data: { givenShoutouts },
  } = useSelector((state) => state.shoutouts);
  const dispatch = useDispatch();
  const [shoutouted, setShoutouted] = useState(true);
  const [isDeleted, setIsDeleted] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);

  const cancelShoutOut = async () => {
    setShoutouted(false);
    const { data: deletedMessage, error } = await axios.delete(
      `${node_server}/api/shoutouts/delete`,
      {
        params: { receiverId: data.receiverId },
        withCredentials: true,
      }
    );

    if (error) console.log(error);
    if (deletedMessage) {
      setIsDeleted(true);
    }
  };

  const handleShoutOutClick = async () => {
    if (shoutouted) {
      cancelShoutOut();
      return;
    }

    setShoutouted(true);
    const { data: newShoutout, error } = await axios.post(
      `${node_server}/api/shoutouts/add`,
      { receiverId: data.receiverId },
      { withCredentials: true }
    );

    if (error) console.log(error);
    if (newShoutout) {
      setIsDeleted(false);
    }
  };

  useEffect(() => {
    if (!user) return;
    if (isDeleted === null) return;

    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }

    if (isDeleted) {
      const id = setTimeout(() => {
        const filteredData = givenShoutouts.filter(
          (item) => item.receiverId !== data.receiverId
        );

        setShoutouted(true);

        dispatch(updateShoutoutsData({ givenShoutouts: filteredData }));
      }, 5000);

      setTimeoutId(id);
    }
  }, [isDeleted]);

  return (
    <Box className={styles.top}>
      <Box className={styles.profile}>
        <Box
          className={styles.image}
          sx={{
            backgroundImage: `url(${data.profileImage})`,
            width: "32px",
            height: "32px",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        ></Box>
        <Box className={styles.name}>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.darkgrey.darkgrey600,
            }}
          >
            {truncateText(data.realName, 5)}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.darkgrey.darkgrey300,
            }}
          >
            {data.nickName}
          </Typography>
        </Box>
      </Box>
      <Box
        onClick={handleShoutOutClick}
        className={styles.Shouts}
        sx={{
          bgcolor: shoutouted
            ? theme.palette.warning.main
            : theme.palette.darkgrey.darkgrey400,
        }}
      >
        <img src={rockAndRoll} width="100%" height="100%" alt="rock-and-roll" />
      </Box>
    </Box>
  );
}

export default Top;
